var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialVk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E9E9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1248_23156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4567 20.1475C32.9401 16.7853 32.3893 16.7224 33 15.6719H28.2409C28.2409 15.6719 27.9027 16.8461 27.7994 17.0563C26.8854 18.9154 24.8351 21.7048 23.5952 21.9899C22.3742 22.2708 22.5363 19.3854 22.6115 18.1356C22.6824 16.9771 22.6703 16.5717 22.6362 16.3715C22.5864 16.0791 22.3411 15.8658 22.0466 15.8286C21.4396 15.7517 20.3383 15.6429 19.1049 15.7001L18.0015 15.7367C18.4365 16.7099 18.7304 16.4116 18.8906 17.5375C19.0715 18.8557 19.0003 22.0632 17.7021 22.0632C15.6209 22.0632 13.2849 15.8127 13.2105 15.6719H9L9.38525 16.6359C12.4902 24.4088 16.3735 28.0088 21.6866 28.3082L22.3781 28.3281L22.4275 27.6567C22.5022 26.6198 23.0224 25.1271 23.9451 25.1271C25.3083 25.1271 25.7021 25.524 26.6012 26.6349C27.4656 27.7001 28.0613 28.3281 29.4562 28.3281H33L32.4946 27.3119C31.7054 25.7275 30.1225 24.3692 29.5043 23.5813C29.2804 23.2847 29.0599 22.8157 29.2881 22.2485C29.4747 21.7545 30.0302 20.7241 30.4567 20.1475Z",
    fill: "#054FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1248_23156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialVk);
export default __webpack_public_path__ + "static/media/social-vk.45bc34f58928f613ee2dbfeca65b057e.svg";
export { ForwardRef as ReactComponent };